import styled from "styled-components";
import DocumentListItem from "../../DocumentListItem";

export const Item = styled(DocumentListItem)`
  margin-top: 16px;
`;
